export function useGetCurrencyIdByCode(code: string): number | 0 {
  const currencyStore = useCurrencyStore()
  // Callers pass codes in either case ("USD" from the API, "usd" from filters),
  // so both sides are normalized before comparing.
  const normalizedCode = code?.toLowerCase()
  const currency = currencyStore.list.find((i) => i.code.toLowerCase() === normalizedCode)

  return currency ? currency.id : 0
}
